import { Component } from '@angular/core';
import {Router} from "@angular/router";
import {APP_ROUTES} from "@app/constants";
import {ButtonDirective} from "primeng/button";

@Component({
  selector: 'app-unauthorized',

  imports: [
    ButtonDirective
  ],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.css'
})
export class UnauthorizedComponent {
  constructor(private router: Router) {

  }
  goBack() {
    this.router.navigate([APP_ROUTES.DASHBOARD]).then();
  }
}
